<template>
    <v-app-bar app light color="white">
        <div class=" d-flex d-md-none">
            <v-app-bar-nav-icon @click="setDrawer(!drawer)"></v-app-bar-nav-icon>
        </div>

        <v-spacer></v-spacer>
        <v-avatar color="indigo">
            <img src="/images/avatars/3.png" alt="John">
        </v-avatar>
    </v-app-bar>
</template>

<script>
export default {
    name: "Header",
    computed: {
        drawer() {
            return this.$store.getters.drawer
        },
    },
    methods: {
        setDrawer(drawer) {
            this.$store.commit('setDrawer', drawer);
        }
    }
}
</script>

<style scoped></style>
